import { ReactNode } from "react";

export default function Overlay({
  children,
  className,
  onClick,
}: {
  children?: ReactNode;
  className?: string;
  onClick: () => void;
}) {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        if (!(e.target instanceof HTMLImageElement || e.target instanceof HTMLVideoElement)) {
          onClick();
        }
      }}
      className={`bg-black bg-opacity-70 fixed inset-0 z-[99999] flex items-center justify-center transition-all duration-500 ${className}`}
    >
      {children}
    </div>
  );
}
